import { Theme, makeStyles } from "@material-ui/core/styles";

export const tabsStyles = makeStyles(({ breakpoints }) => ({
  root: {
    margin: "20px auto 0",
    backgroundColor: "#d3dde9",
    borderRadius: 25,
    minHeight: 45,
    minWidth: "unset",
    color: "#49587f",
  },
  flexContainer: {
    display: "inline-flex",
    position: "relative",
    zIndex: 1,
  },
  scroller: {
    [breakpoints.up("md")]: {
      padding: "0 8px",
    },
  },
  indicator: {
    top: 2,
    bottom: 5,
    right: 3,
    height: "auto",
    background: "none",
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 3,
      left: 4,
      right: 4,
      bottom: 0,
      borderRadius: 25,
      backgroundColor: "#ecf3f8",
      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.16)",
    },
  },
}));

export const tabItemStyles = makeStyles(() => ({
  root: {
    "&:hover": {
      opacity: 1,
    },
    minHeight: 40,
    minWidth: "unset",
    fontFamily: "Lato",
    fontSize: 14,
    fontWeight: 400,
    color: "#45547C",
    paddingTop: 9,
    "&.Mui-selected": {
      color: "#000000",
      fontWeight: 500,
    },
  },
  wrapper: {
    fontWeight: 400,
    textTransform: "initial",
  },
}));

export const purchaseSessionPointsStyles = makeStyles((theme: Theme) => ({
  plansContainer: {
    marginTop: 25,
    width: "380px",
    margin: "auto",
  },
  menuContainer: {
    display: "flex",
  },
  cardContent: {
    padding: "21px 25px",
  },
  cardTitle: {
    color: "#747F9D",
    fontSize: "1.125rem",
    fontFamily: "Lato",
    fontWeight: 400,
    margin: "10px 0",
  },
  productLabel: {
    fontFamily: "Inter",
    color: "#000000",
    fontSize: 16,
  },
  priceContainer: {
    display: "inline-block",
    width: 60,
  },
  separator: {
    border: "solid 0.8px #e4eaec",
  },
  addToCartButton: {
    background: "#0344DC",
    borderRadius: "100px",
    color: "white",
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Inter",
    fontWeight: 600,
    lineHeight: "22.4px",
    margin: "20px 0 10px",
    textTransform: "none",
    border: "none",
    "&:hover": {
      color: "white",
      background: "#0344DC",
    },
    "&:disabled": {
      background: "#E6E6E6",
      color: "#666666",
    },
    "& .MuiButton-endIcon": {
      color: "#22D9BB",
    },
  },
}));
